// @flow
import * as React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import RawStaticFooter from "../../StaticPage/Footer";

import type { Match } from "react-router-dom";

const StaticFooter = styled(RawStaticFooter)`
  @media (max-width: 959px) {
    margin-bottom: 32px;
  }
`;

type Props = {
  match: Match
};

function Footer({ match, showContactUs }: Props) {

  return (
    <React.Fragment>
      <StaticFooter />
    </React.Fragment>
  );
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Footer/Footer.js